import { render, staticRenderFns } from "./Measures.vue?vue&type=template&id=08c2228f&"
import script from "./Measures.vue?vue&type=script&lang=ts&"
export * from "./Measures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports